import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[600px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20film%20reel%20and%20projector%20in%20a%20dimly%20lit%20vintage%20theater%20with%20warm%20golden%20spotlight%20beams%2C%20elegant%20art%20deco%20architecture%2C%20velvet%20red%20curtains%2C%20atmospheric%20smoke%2C%20dramatic%20lighting%20contrast%2C%20luxurious%20cinema%20aesthetic%2C%20moody%20and%20sophisticated%20atmosphere%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20artistic%20composition&width=1800&height=900&seq=hero-cinema-2024&orientation=landscape"
          alt="韩国伦理电影艺术"
          title="韩国伦理电影艺术"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
          {t('hero.title')}
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/forbidden-love"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            <span>{t('hero.cta')}</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-full hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            <span>{t('nav.about')}</span>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}